import { createSlice } from '@reduxjs/toolkit';

const initialState = { isAuthenticated: false };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetAuth(state) {
      state.isAuthenticated = false;
    },
  },
});

export const { resetAuth } = authSlice.actions;
export default authSlice.reducer;
